module.exports = __webpack_public_path__ + "static/media/9.32cfc45d.jpg";